import { c as _c } from "react-compiler-runtime";
import { useStore } from 'zustand';
import useAdobeTarget from '@nike/shop-apis/adobe-target/use-query';

// TODO: MYBAG-5234 Remove this once A/B test is complete
var useErrorModalStore = function useErrorModalStore(selectFromProps) {
  var $ = _c(4);
  var t0;
  if ($[0] === Symbol["for"]("react.memo_cache_sentinel")) {
    t0 = {
      activityName: "EXP1-MYBAG-5138_GLOBAL_WEB_AB_MOBILE/DESKTOP_Save-for-Later_PROD_1",
      experiences: ["A", "B"],
      locationName: "cart_page"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  var _useAdobeTarget = useAdobeTarget(t0),
    experience = _useAdobeTarget.experience;
  var t1;
  if ($[1] !== experience || $[2] !== selectFromProps) {
    t1 = experience === "B" ? function (selectorProps) {
      var _selectorProps$error;
      if ((selectorProps === null || selectorProps === void 0 || (_selectorProps$error = selectorProps.error) === null || _selectorProps$error === void 0 ? void 0 : _selectorProps$error.crcCode) === "BD29FA58") {
        return null;
      }
      return selectFromProps(selectorProps);
    } : selectFromProps;
    $[1] = experience;
    $[2] = selectFromProps;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  var select = t1;
  return useStore(window.NikeShop.__INTERNAL_USE__.stores.errorModal.store, select);
};
export default useErrorModalStore;